import SectionHeading from "@/components/base/SectionHeading";
import ClueCard from "@/components/base/ClueCard";
import { clues } from "@/mocks/clues";

function FeaturedClues() {
  const featured = clues.slice(0, 4);

  return (
    <section className="w-full bg-background-50">
      <div className="w-full px-4 py-14 md:px-8 md:py-20">
        <SectionHeading
          eyebrow="热门线索"
          title="最近被集中关注的几条归档"
          description="以下内容均来自匿名投稿人的陈述与公开资料整理，平台正在按流程核实，最终结论以更新后的页面为准。"
          actionText="查看全部归档"
          actionTo="/clues"
        />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {featured.map((clue) => (
            <ClueCard key={clue.slug} clue={clue} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default FeaturedClues;